import { render, staticRenderFns } from "./FormulaDetails.vue?vue&type=template&id=6a6c5c2e&scoped=true"
import script from "./FormulaDetails.vue?vue&type=script&lang=js"
export * from "./FormulaDetails.vue?vue&type=script&lang=js"
import style0 from "./FormulaDetails.less?vue&type=style&index=0&id=6a6c5c2e&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c5c2e",
  null
  
)

export default component.exports